import { handlerActivarFiltro, echartLineTitol } from './common';

export function echartUsuarisPerTitol(vis, datos) {
  echartLineTitol(
    'chartUsuarisPerTitol',
    'no_dataUsuarisPerTitol',
    datos.resultset,
    "ÚS D'EMT: USUARIS PER TÍTOL",
    false,
  );
}
export function usdEmtUsuarisPerTitol() {
  handlerActivarFiltro();
  $('#idAllFilterFields').show();
  $('#idFieldsFilterEmtUsLinea').hide();
  $('#idFieldsFilterEmtUsTitol').show();
}
